import { render, staticRenderFns } from "./ListMaterials.vue?vue&type=template&id=fa339da4&"
import script from "./ListMaterials.vue?vue&type=script&lang=js&"
export * from "./ListMaterials.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports